import apiRequest from "utils/ApiRequest/apiRequest.js";
import { exampleFormJson } from "./JsonLists.js";

export const getFormDetails = async ({
  formId,
  setFormDetails,
  setFooterDetails,
  setLoading,
  setNotExistForm,
  prevStep1,
  setTypeUser,
}) => {
  if (prevStep1) {
    getFormPreview({
      formId: formId,
      setFormDetails: setFormDetails,
      setNotExistForm: setNotExistForm,
    });
  }
  const parameters = {
    embedDynamicId: formId,
    updateForm: false,
    //fixRequiredDropDown: false,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "GetFormFooterReact",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      if (response.data.EmbedForm) {
        setFormDetails(response.data.EmbedForm);
      } else {
        if (!prevStep1) {
          setNotExistForm(true);
        }
      }
      if (response.data.EmbedFooterLinksList) {
        setFooterDetails(response.data.EmbedFooterLinksList);
      }

      if (response.data.TypeOfOwner) {
        setTypeUser(response.data.TypeOfOwner);
      }
    }
    setLoading(false);
  } else {
    setNotExistForm(true);
    setLoading(false);
  }
};

export const getFormDetailsExampleJson = async ({
  formId,
  setFormDetails,
  setFooterDetails,
}) => {
  const response = exampleFormJson;
  if (response) {
    if (response.EmbedForm) {
      setFormDetails(response.EmbedForm);
    }
    if (response.EmbedFooterLinksList) {
      setFooterDetails(response.EmbedFooterLinksList);
    }
  }
};

const getFormPreview = async ({ formId, setFormDetails, setNotExistForm }) => {
  const parameters = {
    embedDynamicPreviewId: formId,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "GetEmbedDynamicFormPreview",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      let displayTitle = response.data.Embed_Dynamic_Display_Title;
      response.data.Embed_Dynamic_Inner_Title = displayTitle;
      setFormDetails(response.data);
    } else {
      setNotExistForm(true);
    }
  }
};

//form-continue
export const getSpecificReactConst = async ({ key, lang, setState }) => {
  let shortLang = lang;
  if (lang && lang.includes("-")) {
    shortLang = lang.split("-")[0];
  }
  const parameters = {
    constKey: key,
    lang: shortLang,
  };
  const response = await apiRequest(
    "Translations",
    "GetSpecificReactConst",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      setState(response.data);
    }
  }
};

export const createEmbedMailReact = async ({
  embedFormId,
  embedJsonLeads,
  setStartUpload,
  setEmbedMailId,
  setLoadingButton,
  setReactCookies,
  EmbedExternalTransactionId,
  setLoading,
  skipForm,
  recaptchaResponse,
}) => {
  setLoadingButton(true);
  const body = {
    EmbedUserId: "",
    EmbedDynamicFormId: embedFormId,
    EmbedDynamicLeadsJson: JSON.stringify(embedJsonLeads),
    EmbedExternalTransactionId: EmbedExternalTransactionId,
    EmbedSessionId: "",
    RecaptchaResponse: recaptchaResponse,
  };
  const response = await apiRequest(
    "Mails",
    "CreateEmbedMailReact",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
      if (response.data.Result === 0) {
        setStartUpload(true);
        setEmbedMailId(response.data.MailSid);
        if (response.data.ReactCookies && response.data.ReactCookies !== {}) {
          setReactCookies(response.data.ReactCookies);
        }
      }
    }
    setLoadingButton(false);
  } else {
    setLoadingButton(false);
    if (response.data === "CaptchaRequired") {
      return { status: "error", data: "CaptchaRequired" };
    }
  }

  if (skipForm) {
    setLoading(false);
  }

  return response;
};

export const getMailShortDetails = async (mailId) => {
  const parameters = {
    encryptMailId: mailId,
  };
  return await apiRequest("Mails", "ReactGetMailShortDetails", parameters);
};

export const getEmbedDynamicFormCultureByFormId = async ({ embedFormId }) => {
  const parameters = {
    formId: embedFormId,
  };
  return await apiRequest(
    "EmbedDynamics",
    "GetEmbedDynamicFormCultureByFormId",
    parameters
  );
};

export const getEmbedFormCookiesByFormId = async ({
  embedFormId,
  setPrevCookies,
}) => {
  const parameters = {
    EmbedFormId: embedFormId,
  };

  const res = await apiRequest(
    "EmbedDynamics",
    "GetEmbedFormCookiesByFormId",
    parameters
  );
  if (res.status === "success") {
    if (res.data) {
    }
  }
};

export const updateDynamicStatistic = async ({ embedDynamicId, embedUrl }) => {
  const body = {
    EmbedDynamicId: embedDynamicId,
    StatisticEmbedUrl: embedUrl,
    Type: "check",
  };

  const res = await apiRequest(
    "EmbedDynamics",
    "UpdateDynamicStatistic",
    body,
    "POST"
  );
  if (res.status === "success") {
    if (res.data) {
    }
  }
};

export const updateJumboFormExternalWebsite = async ({
  embedDynamicId,
  websiteLink,
}) => {
  const body = {
    EmbedDynamicId: embedDynamicId,
    StatisticEmbedUrl: websiteLink,
  };

  const res = await apiRequest(
    "EmbedDynamics",
    "UpdateJumboFormExternalWebsite",
    body,
    "POST"
  );
  if (res.status === "success") {
    if (res.data) {
    }
  }
};
